<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="repertoireName.length == 0" @click="confirm" :strong="true">
          {{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding" color="light">
    <ion-item ion-text-center>
      <span class="labelWidth">{{ t("Repertoire") }} :</span> {{ originalName }}
    </ion-item>
    <ion-item>
      <ion-input :label="label" label-placement="fixed" 
                  :placeholder="placeHolderString" :value="repertoireName"
                  @ionInput="nameChange">
      </ion-input>
    </ion-item>
  </ion-content>
</template>

<script  setup>
  import {
    IonRadio,
    IonRadioGroup,
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonLabel,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  const props = defineProps({
    action : String,
    name : String,
    repertoireId : String
	})

  const title = ref((props.action == "copy") ? t("Copy Repertoire") : t("Rename Repertoire"))
  const label = ref((props.action == "copy") ? t("Copy To") + ":" : t("Rename To") + ":")
  const originalName = ref(props.name);

  const repertoireName = ref("")
  const placeHolderString = ref(t("Enter name"))

  const cancel = () => modalController.dismiss(null, 'cancel');

  function confirm() {
    var result = { 
                 name : repertoireName.value,
                 repertoireId : props.repertoireId
    }

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function nameChange(ev) {
    //console.log("name ",ev)
    const value = ev.target.value;
    //console.log("repertoire name ",value)
    repertoireName.value = value.trim()
  }

</script>

<style scoped>

  .labelWidth {
    width: 150px;
  }

</style>
